window.Accordion = (accordionId) => {
	return {
		active_section: null,

		init() {
			let selector = "#" + accordionId + " [id^=\'components-accordion-tab-block\'] > div";
			let first = document.querySelector(selector)
			console.log(first.id);
			this.active_section = first.id;
		}
	};
};
